import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import * as _ from 'underscore';
import { tap } from 'rxjs/operators';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../environments/environment';

const STATE_KEY_PRODUCTS = makeStateKey('consumer_lists_products');
const STATE_KEY_EFFECTS = makeStateKey('consumer_lists_effects');
const STATE_KEY_GAMA = makeStateKey('consumer_lists_gama');
const STATE_KEY_TYPES = makeStateKey('consumer_lists_types');

@Injectable({
  providedIn: 'root'
})
export class ListsService {

  data = {
    produkty: [],
    efekty: [],
    gamy: [],
    typy: []
  };

  constructor(
    private dataService: DataService,
    private state: TransferState,
    private http: HttpClient
  ) {

    this.data.produkty = this.state.get(STATE_KEY_PRODUCTS, <any>[]);
    this.data.efekty = this.state.get(STATE_KEY_EFFECTS, <any>[]);
    this.data.gamy = this.state.get(STATE_KEY_GAMA, <any>[]);
    this.data.typy = this.state.get(STATE_KEY_TYPES, <any>[]);

    if (this.data.produkty.length == 0) {


      this.http.get(`${environment.apiUrl}/platform/product-categories`)
        .subscribe((res: any) => {
        this.data.produkty = res;
        this.state.set(STATE_KEY_PRODUCTS, <any>res);
      });
    }

    if (this.data.efekty.length == 0) {

      this.http.get(`${environment.apiUrl}/platform/product-effects`)
        .pipe(tap((res: any) => {
        res.forEach(item => {
          item.name = item.name.charAt(0).toUpperCase() + item.name.slice(1);
        });
      }))
      .subscribe((res: any) => {
        this.data.efekty = res;
        this.state.set(STATE_KEY_EFFECTS, <any>res);
      });
    }

    if (this.data.gamy.length == 0) {
      this.http.get(`${environment.apiUrl}/platform/product-gama`)
        .subscribe((res: any) => {
        this.data.gamy = res;
        this.state.set(STATE_KEY_GAMA, <any>res);
      });
    }

    // if (this.data.typy.length == 0) {
    //   this.dataService.invoke(`/platform/product-types`).subscribe(res => {
    //     this.data.typy = res;
    //     this.state.set(STATE_KEY_TYPES, <any>res);
    //   });
    // }
  }

  getItem(object, slug) {
    return _.findWhere(this.data[object], {slug: slug});
  }
}
